import { Link, useParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import PostCard from "@/components/feature/PostCard";
import PostListItem from "@/components/feature/PostListItem";
import { categories, posts } from "@/mocks/posts";

export default function CategoryPage() {
  const { slug } = useParams();
  const category = categories.find((item) => item.slug === slug) ?? categories[0];
  const list = posts.filter((item) => item.categorySlug === category.slug);
  const others = posts.filter((item) => item.categorySlug !== category.slug).slice(0, 5);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />

      <section className="w-full border-b border-background-200/70 bg-background-100">
        <div className="w-full px-4 md:px-8 py-10 md:py-14">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-5">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-foreground-700">{category.name}</span>
          </nav>
          <div className="flex items-start gap-4">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-3xl">
              <i className={category.icon} aria-hidden="true"></i>
            </span>
            <div>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                {category.name}
              </h1>
              <p className="mt-2 max-w-2xl text-sm md:text-base text-foreground-600">
                {category.description}
              </p>
              <p className="mt-3 text-xs text-foreground-500">
                共 {category.count} 条内容 · 持续更新中
              </p>
            </div>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {categories.map((item) => (
              <Link
                key={item.slug}
                to={`/category/${item.slug}`}
                className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  item.slug === category.slug
                    ? "bg-primary-500 text-background-50 font-semibold"
                    : "bg-background-50 border border-background-200/70 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <main className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-8">
            {list.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
                {list.map((post) => (
                  <PostCard key={post.id} post={post} />
                ))}
              </div>
            ) : (
              <div className="rounded-lg border border-background-200/70 bg-background-50 p-10 text-center">
                <i className="ri-inbox-line text-4xl text-foreground-300" aria-hidden="true"></i>
                <p className="mt-3 text-sm text-foreground-600">这个分类暂时还没有内容，先去别处逛逛？</p>
                <Link
                  to="/"
                  className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-primary-600"
                >
                  回到首页
                </Link>
              </div>
            )}
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950 mb-1">
                <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
                其他基地热瓜
              </h2>
              <div className="divide-y divide-background-200/70">
                {others.map((item, index) => (
                  <PostListItem key={item.id} post={item} rank={index + 1} />
                ))}
              </div>
            </div>
          </aside>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}